import {MarketService} from "./marketService";

export class PriceFormatter {
    private market: MarketInterface;
    constructor() {
        this.market = new MarketService().getCurrent();
    }

    getPrice(price): string {
        return Math.round(parseFloat(price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    getPriceWithCurrency(price, plusSign = false, pricePerArea = false): string {
        if (this.market.get().currency === 'NOK') {
            return ((plusSign) ? '+' : '') + ((pricePerArea) ? 'kr/m2 ' : 'kr ') + this.getPrice(price);
        }

        return ((plusSign) ? '+' : '') + this.getPrice(price) + ((pricePerArea) ? ' kr/m2' : ' kr');
    }
}
